export enum TIPOZOOM {
  DEFAULT = 6,
  ESCRITORIO_PEC = 12,
  MOBILE_PEC = 12,
}
